import { Cloud$MainHardwareType } from '@otovo/shared/types/cloudEnums';
import AddressSearchBar from '../AddressSearchBar';
type Props = {
  mainHardwareType: Cloud$MainHardwareType;
  description?: string;
};
const HeroAddressSearchBar = ({ mainHardwareType, description }: Props) => {
  return (
    <>
      <div className="text-grey-90">
        <AddressSearchBar mainHardwareType={mainHardwareType} />
      </div>
      {description && (
        <p className="mt-3 text-sm text-inherit">
          {/* TODO: Description should be semantically linked to the address bar */}
          {description}
        </p>
      )}
    </>
  );
};

export default HeroAddressSearchBar;
